import  NetworkHandler from 'utils/network';
import config from 'config';

function getMemberById(id) {
    return NetworkHandler.get(`${config.getUrl('bus_members')}/${id}`);
}

function getMemberByKeyword(keyword) {
    return NetworkHandler.get(`${config.getUrl('bus_members')}`,{
        params: {
            page: 0,
            size: 100,  
            keyword
        }
    });
}

export default {
    getMemberById,
    getMemberByKeyword,
};